import { __assign, __rest } from "tslib";
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import uniqueId from '../utilities/uniqueId';
import './TextArea.scss';
var TextAreaWidths = {
    FULL: 'full',
    LARGE: 'large',
    MEDIUM: 'medium',
    SMALL: 'small'
};
var TextArea = function (_a) {
    var className = _a.className, errorMessage = _a.errorMessage, inputClassName = _a.inputClassName, isDisabled = _a.isDisabled, isRequired = _a.isRequired, label = _a.label, onChange = _a.onChange, placeholder = _a.placeholder, value = _a.value, width = _a.width, props = __rest(_a, ["className", "errorMessage", "inputClassName", "isDisabled", "isRequired", "label", "onChange", "placeholder", "value", "width"]);
    var inputId = useRef(uniqueId('input'));
    var containerClass = classnames('TextArea', className);
    var inputClass = classnames('TextArea__input', "TextArea__input--".concat(width), {
        'TextArea__input--isInvalid': Boolean(errorMessage)
    }, inputClassName);
    return (React.createElement("div", __assign({}, props, { className: containerClass }),
        label && (React.createElement("label", { className: 'TextArea__label', htmlFor: inputId.current },
            isRequired ? React.createElement("span", { "aria-hidden": 'true' }, "* ") : null,
            label)),
        React.createElement("textarea", { className: inputClass, disabled: isDisabled, id: inputId.current, onChange: function (event) { return onChange(event.target.value); }, placeholder: placeholder, required: isRequired, value: value !== null && value !== void 0 ? value : '' }),
        errorMessage && (React.createElement("div", { className: 'TextArea__errorMessage', role: 'alert' }, errorMessage))));
};
TextArea.defaultProps = {
    isDisabled: false,
    isRequired: false,
    onBlur: function () { },
    value: '',
    width: TextAreaWidths.MEDIUM
};
TextArea.propTypes = {
    className: PropTypes.string,
    errorMessage: PropTypes.node,
    inputClassName: PropTypes.string,
    isDisabled: PropTypes.bool,
    isRequired: PropTypes.bool,
    label: PropTypes.node,
    onBlur: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    width: PropTypes.oneOf(Object.values(TextAreaWidths))
};
export default TextArea;
//# sourceMappingURL=TextArea.js.map